import * as actions from "../actions/Type";
const intialState = {
  agent: {},
  list_agents: [],
  branch_object: {},
  view_edit_agent: {},
  name: "",
  create_bounes: {},
  list_punshed_agent: [],
  view_bounes: {},
  agent_name: {},
  // loading
  agent_status: false,
  // salary form
  create_salary: {},
  list_salary_agent: [],
  view_salary: {},
  agent_name_salary: {},
  // persentage
  create_persentage: {},
  list_persentage_agent: [],
  view_persentage: {},
  agent_name_persentage: {},
};
const AgentReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.GET_LIST_AGENTS:
      return {
        ...state,
        list_agents: action.payload,
        agent_status: action.agent_status,
      };
    case actions.CREATE_AGENT:
      return {
        ...state,
        agent: action.payload,
      };
    case actions.GET_BRANCH_OBJECT:
      return {
        ...state,
        branch_object: action.payload,
      };

    case actions.UPDATE_NAME_BRANCH:
      return {
        ...state,
      };
    case actions.UPDATE_NAME_AGENT:
      return {
        ...state,
        agent: action.payload,
      };
    case actions.VIEW_EDIT_AGENT:
      return {
        ...state,
        view_edit_agent: action.payload.doc,
        name: action.payload.name,
      };
    case actions.UPDATEING_AGENT_STATUS:
      return {
        ...state,
      };
    case actions.CREATE_PUNSHED_AGENT:
      return {
        ...state,
        create_bounes: action.payload,
        list_punshed_agent: [action.payload, ...state.list_punshed_agent],
      };
    case actions.GET_LIST_AGENTS_PUNSHED:
      return {
        ...state,
        list_punshed_agent: action.payload,
      };
    case actions.VIEW_PUNSHED:
      return {
        ...state,
        view_bounes: action.payload,
        agent_name: action.agent_name,
      };
    case actions.UPDATE_PUNSHED:
      return {
        ...state,
      };
    case actions.DELETE_PUNSHED:
      return {
        ...state,
        list_punshed_agent: state.list_punshed_agent.filter(
          (el) => el._id !== action.id
        ),
      };
    // FORM SALARY
    case actions.CREATE_FORM_SALARY:
      return {
        ...state,
        create_salary: action.payload,
        list_salary_agent: [action.payload, ...state.list_salary_agent],
      };
    case actions.GET_LIST_FORM_SALARY:
      return {
        ...state,
        list_salary_agent: action.payload,
      };
    case actions.VIEW_FORM_SALARY:
      return {
        ...state,
        view_salary: action.payload,
        agent_name_salary: action.agent_name_salary,
      };
    case actions.UPDATE_FORM_SALARY:
      return {
        ...state,
      };
    case actions.DELETE_FORM_SALARY:
      return {
        ...state,
        list_salary_agent: state.list_salary_agent.filter(
          (el) => el._id !== action.id
        ),
      };
    // PERSENTAGE FORM
    case actions.CREATE_FORM_PERSENTAGE:
      return {
        ...state,
        create_persentage: action.payload,
        list_persentage_agent: [action.payload, ...state.list_persentage_agent],
      };
    case actions.GET_LIST_FORM_PERSENTAGE:
      return {
        ...state,
        list_persentage_agent: action.payload,
      };
    case actions.VIEW_FORM_PERSENTAGE:
      return {
        ...state,
        view_persentage: action.payload,
        agent_name_persentage: action.agent_name_persentage,
      };
    case actions.UPDATE_FORM_PERSENTAGE:
      return {
        ...state,
      };
    case actions.DELETE_FORM_PERSENTAGE:
      return {
        ...state,
        list_persentage_agent: state.list_persentage_agent.filter(
          (el) => el._id !== action.id
        ),
      };
    default:
      return { ...state };
  }
};

export default AgentReducer;
